import React, { FC } from 'react';
import { BlankLink, BookCoverImage } from '../../../shared/components';

type Props = {
  image: string;
  to: string;
  className?: string;
};
const BookCoverImageLink: FC<Props> = ({ image, to, className }) => (
  <BlankLink to={to}>
    <BookCoverImage className={className} image={image} />
  </BlankLink>
);

export default BookCoverImageLink;
